export default "__VITE_ASSET__544f483c__"